import { useState, useEffect, useMemo } from 'react';
import createAxiosInstance from "../utils/axiosInstance";
import { API_ENDPOINTS } from "../utils/api";
import { Agency } from '../type/Agency';

const useAgencies = () => {
    const axiosInstance = createAxiosInstance();

    const [agencyData, setAgencyData] = useState<Agency[] | null>(null);

    useEffect(() => {
        const getAgencyData = async () => {
        try {
            const data = await axiosInstance.get<Agency[]>(`${API_ENDPOINTS.BEDFINDER.GETMYAGENCY}`);

            setAgencyData(data.data);
            // console.log('Fetched data:', data);  // Log the fetched data
        } catch (err) {
            console.log('Error fetching data:', err instanceof Error ? err.message : err);  // Log error
        }
        };

        getAgencyData();
    }, []);

    return { agenciesById: useMemo(
            () =>
            (agencyData ?? []).reduce(
                (obj: any, curr: any) => ({ ...obj, [curr.agencyId]: curr }),
                {} as Record<string, Agency>,
            ),
            [agencyData],
        ), 
        agencies: agencyData ?? [] 
    };
};

export default useAgencies;
